module.exports = __webpack_public_path__ + "static/media/walkinswelcomeicon.0b4b31eb.svg";